(function () {
  var CFG = window.SDA_GIFT || {};
  // Multi-tier gifts. If window.SDA_GIFT.gifts is provided, use it; otherwise
  // default to masks (from legacy config) PLUS the Curenex Exo tier at $200.
  // 2026-10-04: gifts are now dedicated hidden "Free Gift" products so a box a
  // customer buys can never be confused with a gift by the discount.
  var GIFTS = (CFG.gifts && CFG.gifts.length)
    ? CFG.gifts.map(function (g) { return { variant: Number(g.variant), threshold: Number(g.threshold) }; })
    : [
        { variant: 67628151701783, threshold: Number(CFG.threshold || 15000) },
        { variant: 67628151734551, threshold: 20000 }
      ];
  // Old gift variants (before 2026-10-04). Any line still carrying _free_gift
  // on these is removed so carts left open from before do not keep them.
  var LEGACY = [52561867276567, 54761403744535];
  var GIFT_VARIANTS = GIFTS.map(function (g) { return g.variant; });
  var processing = false;
  var timer = null;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function itemTotal(it) {
    if (typeof it.final_line_price === 'number') return it.final_line_price;
    if (typeof it.line_price === 'number') return it.line_price;
    return (it.price || 0) * (it.quantity || 0);
  }
  function isGiftLine(it) {
    return (GIFT_VARIANTS.indexOf(Number(it.variant_id)) > -1 || LEGACY.indexOf(Number(it.variant_id)) > -1) && it.properties && (it.properties._free_gift === 'true' || it.properties['_free_gift'] === 'true');
  }
  function qualifying(cart) {
    var t = 0;
    ((cart && cart.items) || []).forEach(function (it) { if (!isGiftLine(it)) t += itemTotal(it); });
    return t;
  }
  function giftQty(cart, variant) {
    var q = 0;
    ((cart && cart.items) || []).forEach(function (it) { if (isGiftLine(it) && Number(it.variant_id) === variant) q += it.quantity; });
    return q;
  }
  function giftKey(cart, variant) {
    var k = null;
    ((cart && cart.items) || []).forEach(function (it) { if (isGiftLine(it) && Number(it.variant_id) === variant && !k) k = it.key; });
    return k;
  }
  function fmt(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }
  function updateBars(cart) {
    var qt = qualifying(cart);
    document.querySelectorAll('[data-sda-giftbar]').forEach(function (bar) {
      var thr = Number(bar.getAttribute('data-threshold')) || 0;
      var style = bar.getAttribute('data-style') || 'progress';
      var reward = bar.getAttribute('data-reward') || 'a free gift';
      var gift = bar.getAttribute('data-gift') || '';
      var giftname = bar.getAttribute('data-giftname') || 'free gift';
      var deadline = bar.getAttribute('data-deadline') || '';
      var remaining = thr - qt;
      var pct = thr > 0 ? Math.min(100, Math.round((qt * 100) / thr)) : 0;
      var fill = bar.querySelector('[data-sda-fill]');
      if (fill) fill.style.width = pct + '%';
      var head = bar.querySelector('[data-sda-headline]');
      if (!head) return;
      if (remaining > 0) {
        bar.classList.remove('is-unlocked');
        head.className = 'sda-giftbar__headline';
        if (style === 'urgency') {
          head.innerHTML = 'Add <strong>' + fmt(remaining) + '</strong> more today and unlock a <strong>' + giftname + '</strong>' + (gift ? ', a ' + gift + ' treat' : '') + (deadline ? '. ' + deadline : '');
        } else {
          head.innerHTML = 'You are <strong>' + fmt(remaining) + '</strong> away from ' + reward + '.';
        }
      } else {
        bar.classList.add('is-unlocked');
        head.className = 'sda-giftbar__headline sda-giftbar__headline--win';
        head.innerHTML = 'You have unlocked ' + reward + '. Your ' + giftname + ' is in the cart, on us.' + ((deadline && style === 'urgency') ? ' ' + deadline : '');
      }
    });
  }
  function bundleSections() {
    var s = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: s } }));
    return s;
  }
  function refresh(sections) {
    return getCart().then(function (cart) {
      cart.sections = sections || {};
      try {
        if (window.FoxTheme && FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: 'sda-gift' });
        }
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      updateBars(cart);
      return cart;
    });
  }
  function mutate(url, body) {
    body.sections = bundleSections().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) { return refresh(parsed && parsed.sections); });
  }
  function reconcile() {
    if (processing) return;
    processing = true;
    getCart()
      .then(function (cart) {
        updateBars(cart);
        var qt = qualifying(cart);
        var actions = [];
        var legacy = {};
        var hasLegacy = false;
        ((cart && cart.items) || []).forEach(function (it) {
          var isFree = it.properties && it.properties._free_gift === 'true';
          if (isFree && LEGACY.indexOf(Number(it.variant_id)) > -1) { legacy[it.key] = 0; hasLegacy = true; }
        });
        if (hasLegacy) {
          return mutate('/cart/update.js', { updates: legacy }).then(function () { setTimeout(schedule, 900); });
        }
        GIFTS.forEach(function (g) {
          var gq = giftQty(cart, g.variant);
          var desired = qt >= g.threshold ? 1 : 0;
          if (gq === desired) return;
          if (desired === 1 && gq === 0) actions.push({ type: 'add', variant: g.variant });
          else if (desired === 0 && gq > 0) { var rk = giftKey(cart, g.variant); if (rk) actions.push({ type: 'change', key: rk, quantity: 0 }); }
          else if (desired === 1 && gq > 1) { var ck = giftKey(cart, g.variant); if (ck) actions.push({ type: 'change', key: ck, quantity: 1 }); }
        });
        if (!actions.length) return null;
        return actions.reduce(function (p, a) {
          return p.then(function () {
            if (a.type === 'add') return mutate('/cart/add.js', { items: [{ id: a.variant, quantity: 1, properties: { _free_gift: 'true' } }] });
            return mutate('/cart/change.js', { id: a.key, quantity: a.quantity });
          });
        }, Promise.resolve());
      })
      .catch(function (e) { if (window.console) console.error('SDA gift error', e); })
      .then(function () { setTimeout(function () { processing = false; }, 500); });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 250); }

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) updateBars(e.detail.cart);
    schedule();
  });
  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
})();
